<template>
    <footer class="text-sm md:text-base bg-white mt-12" aria-labelledby="footer-heading">
        <h2 id="footer-heading" class="sr-only">Footer</h2>
        <Container class="pb-8 pt-8 sm:pt-16 lg:px-8 lg:pt-16">
            <div class="xl:grid xl:grid-cols-2 xl:gap-8">
                <div class="space-y-8">
                    <ApplicationLogo
                        class="block h-9 w-auto fill-current text-gray-800"
                    />
                    <!-- <p class="text-sm leading-6 text-gray-600">Уютный магазин товаров ручной работы</p> -->
                    <div class="flex space-x-6">
                        <a v-for="item in navigation.social" :key="item.name" :href="item.href" target="_blank" rel="nofollow" class="text-gray-400 hover:text-gray-500">
                            <span class="sr-only">{{ item.name }}</span>
                            <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
                        </a>
                    </div>
                </div>
                <div class="mt-16 grid grid-cols-1 gap-8 xl:col-span-1 xl:mt-0">
                    <div class="md:grid md:grid-cols-3 md:gap-8">
                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm font-semibold leading-6 text-gray-900">Продавцам</h3>
                            <ul role="list" class="mt-4 space-y-4">
                                <li v-for="item in navigation.sellers" :key="item.name">
                                    <a :href="item.href" class="text-sm leading-6 text-gray-600 hover:text-gray-900" rel="nofollow" target="_blank">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3 class="text-sm font-semibold leading-6 text-gray-900">Покупателям</h3>
                            <ul role="list" class="mt-4 space-y-4">
                                <li v-for="item in navigation.buyers" :key="item.name">
                                    <a :href="item.href" class="text-sm leading-6 text-gray-600 hover:text-gray-900">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm font-semibold leading-6 text-gray-900">Компания</h3>
                            <ul role="list" class="mt-4 space-y-4">
                                <li v-for="item in navigation.company" :key="item.name">
                                    <a :href="item.href" class="text-sm leading-6 text-gray-600 hover:text-gray-900">{{ item.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24">
                <p class="text-xs leading-5 text-gray-500">&copy; 2024 Призрачная полка. Все права защищены.</p>
            </div>
        </Container>
    </footer>
</template>

<script setup>
import { defineComponent, h } from 'vue'
import Container from './Container.vue';
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

const navigation = {
    sellers: [
        { name: 'Аренда полок', href: 'https://seller.ghostshelf.shop' },
        { name: 'Кабинет продавца', href: route('login') },
        { name: 'Вопрос-ответ', href: route('faq') },
    ],
    buyers: [
        { name: 'Оплата', href: route('market.info.payment') },
        { name: 'Доставка', href: route('market.info.delivery') },
        { name: 'Возврат товаров', href: route('market.info.returns')},
    ],
    company: [
        { name: 'Каталог товаров', href: route('market.catalog')},
        { name: 'Наши магазины', href: route('market.info.contacts') },
        // { name: 'Бонусная система', href: route('market.info.bonus') },
    ],
    social: [
        // {
        //     name: 'YouTube',
        //     href: '#',
        //     icon: defineComponent({
        //         render: () =>
        //             h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
        //                 h('path', {
        //                     'fill-rule': 'evenodd',
        //                     d: 'M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z',
        //                     'clip-rule': 'evenodd',
        //                 }),
        //             ]),
        //     }),
        // },
        {
            name: 'VK',
            href: 'https://vk.com/ghostshelf',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                        h('path', {
                            'fill-rule': 'evenodd',
                            d: 'm23.456 5.784c-.27.849-.634 1.588-1.09 2.259l.019-.03q-.672 1.12-1.605 2.588-.8 1.159-.847 1.2c-.138.173-.234.385-.267.618l-.001.007c.027.212.125.397.268.535l.4.446q3.21 3.299 3.611 4.548c.035.092.055.198.055.309 0 .194-.062.373-.167.52l.002-.003c-.176.181-.422.293-.694.293-.03 0-.061-.001-.09-.004h.004-2.631c-.001 0-.003 0-.005 0-.337 0-.647-.118-.89-.314l.003.002c-.354-.291-.669-.606-.951-.948l-.009-.012q-.691-.781-1.226-1.315-1.782-1.694-2.63-1.694c-.021-.002-.045-.003-.07-.003-.165 0-.319.051-.446.138l.003-.002c-.104.13-.167.298-.167.479 0 .036.002.07.007.105v-.004c-.027.314-.043.679-.043 1.048 0 .119.002.237.005.355v-.017 1.159c.01.047.016.101.016.156 0 .242-.11.458-.282.601l-.001.001c-.387.177-.839.281-1.316.281-.102 0-.202-.005-.301-.014l.013.001c-1.574-.03-3.034-.491-4.275-1.268l.035.02c-1.511-.918-2.763-2.113-3.717-3.525l-.027-.042c-.906-1.202-1.751-2.56-2.471-3.992l-.07-.154c-.421-.802-.857-1.788-1.233-2.802l-.06-.185c-.153-.456-.264-.986-.31-1.535l-.002-.025q0-.758.892-.758h2.63c.024-.002.052-.003.081-.003.248 0 .477.085.658.228l-.002-.002c.2.219.348.488.421.788l.003.012c.484 1.367.997 2.515 1.587 3.615l-.067-.137c.482.97 1.015 1.805 1.623 2.576l-.023-.031q.8.982 1.248.982c.009.001.02.001.032.001.148 0 .277-.08.347-.2l.001-.002c.074-.19.117-.411.117-.641 0-.049-.002-.098-.006-.146v.006-3.879c-.021-.457-.133-.884-.32-1.267l.008.019c-.124-.264-.273-.492-.45-.695l.003.004c-.164-.164-.276-.379-.311-.619l-.001-.006c0-.17.078-.323.2-.423l.001-.001c.121-.111.283-.178.46-.178h.008 4.146c.022-.003.047-.004.073-.004.195 0 .37.088.486.226l.001.001c.103.188.164.413.164.651 0 .038-.002.075-.005.112v-.005 5.173c-.002.024-.003.052-.003.08 0 .184.051.357.139.504l-.002-.004c.073.108.195.178.333.178h.001c.176-.012.336-.07.471-.162l-.003.002c.272-.187.506-.4.709-.641l.004-.005c.607-.686 1.167-1.444 1.655-2.25l.039-.07c.344-.57.716-1.272 1.053-1.993l.062-.147.446-.892c.155-.446.571-.76 1.06-.76.019 0 .038 0 .057.001h-.003 2.631q1.066 0 .8.981z',
                            'clip-rule': 'evenodd',
                        }),
                    ]),
            }),
        },
    ],
}
</script>
